import React from 'react';

import logo from '../../../../assets/images/logofcblue.png'

// NOTE: Added the styles here.
// Somehow putting this styles inside a css file does not work.
// TODO: Get back on this.

const containerStyle = {
  height: '100vh',
  width: '100wh',
  backgroundColor: 'transparent',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
}

const logoStyle = {
  fontColor: '#000',
  height: '100px',
  width: '100px'
}

class CompanyLoader extends React.Component {
  render() {
    return (
      <div style={containerStyle}>
        <div className="reverse-spinner">
          <img
            style={logoStyle}
            alt="First Circle"
            src={logo}
          />
        </div>
      </div>
    )
  }
}

export default CompanyLoader;



// WEBPACK FOOTER //
// ./src/features/shared/components/loaders/CompanyLoader.js